export default __webpack_public_path__ + "static/media/sam-and-karen-building-night.abbbaffb.jpeg";